import i18next from 'i18next';

const EXTERNAL_CLIENT_CREATION = {
  isFullScreen: true,
  path: '/external/clients/create',
  isVisible: () => false,
};

const EXTERNAL_CLIENT_DETAILS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('GENERAL.INFORMATIONS'),
  path: '/external/clients/:id/details',
  getLink: ({ externalClientId }) => `/external/clients/${externalClientId}/details`,
};

const EXTERNAL_CLIENT_CATALOG = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('EXTERNAL_CLIENTS.DETAILS.CATALOG_TAB'),
  path: '/external/clients/:id/catalog',
  getLink: ({ externalClientId }) => `/external/clients/${externalClientId}/catalog`,
};

const EXTERNAL_CLIENTS = {
  getText: () => i18next.t('FEATURE.EXTERNAL.CLIENTS'),
  path: '/external/clients',
  getBreadCrumbText: () => i18next.t('FEATURE.EXTERNAL.CLIENTS'),
  customRender: ({ externalClient }) => ({
    linkedText: i18next.t('FEATURE.EXTERNAL.CLIENTS'),
    extraText: `/ ${externalClient && externalClient.name ? externalClient.name : ''}`,
    backLink: '/external/clients',
  }),
  subFeatures: [EXTERNAL_CLIENT_CREATION, EXTERNAL_CLIENT_DETAILS, EXTERNAL_CLIENT_CATALOG],
};

const EXTERNAL_ORDER_CREATION = {
  isFullScreen: true,
  path: '/external/orders/create',
  isVisible: () => false,
};

const EXTERNAL_ORDER_DETAILS = {
  isFullScreen: true,
  path: '/external/orders/:id/details',
  getLink: ({ externalOrderId }) => `/external/orders/${externalOrderId}/details`,
  isVisible: () => false,
};

const EXTERNAL_ORDERS = {
  getText: () => i18next.t('FEATURE.EXTERNAL.ORDERS'),
  path: '/external/orders',
  getBreadCrumbText: () => i18next.t('FEATURE.EXTERNAL.ORDERS'),
  subFeatures: [EXTERNAL_ORDER_CREATION, EXTERNAL_ORDER_DETAILS],
};

const EXTERNAL_SUBMODULE = {
  getText: () => i18next.t('FEATURE.EXTERNAL.EXTERNAL'),
  icon: '/images/shopping-bag.svg',
  children: [EXTERNAL_CLIENTS, EXTERNAL_ORDERS],
  hideSubmoduleName: true,
};

export const EXTERNAL = {
  getText: () => i18next.t('FEATURE.EXTERNAL.EXTERNAL'),
  path: '/external',
  icon: '/images/shopping-bag.svg',
  children: [EXTERNAL_SUBMODULE],
};
